<template>
  <ul class="zg-faq">
    <zg-faq-list-item
      v-for="(item, index) in faqs"
      :key="index"
      :question="item.question"
      :answer="item.answer"
      :tabindex="index"
      class="item"
    />
  </ul>
</template>

<script>
  import ZgFaqListItem from './ZgFaqListItem.vue'

  export default {
    name: 'ZgFaq',
    components: {
      ZgFaqListItem
    },
    props: {
      faqs: {
        type: Array,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .zg-faq {
    padding: 0;

    .item:last-child {
      border-bottom: none;
    }
  }
</style>
